import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { BUSINESS_NAME, HUB_PATHS } from "@/lib/site";
import { PARTNER_ID } from "@/lib/catalog";
import { HeaderSearch } from "@/components/HeaderSearch";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/", label: "Início" },
  { to: HUB_PATHS.progressiva, label: "Progressiva" },
  { to: HUB_PATHS.progressivaOficial, label: "Loja Oficial" },
  { to: HUB_PATHS.cronograma, label: "Cronograma" },
  { to: HUB_PATHS.antiqueda, label: "100Tímetros" },
  { to: HUB_PATHS.oleoMirra, label: "Óleo de Mirra" },
  { to: HUB_PATHS.soroVello, label: "Soro Vello" },
];

const BAR = "bg-[#3a3a3a]";

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      <div className={`${BAR} text-white`}>
        <p className="container py-1.5 text-center text-xs tracking-wide md:text-sm">
          Você está na loja do parceiro:{" "}
          <span className="font-semibold tabular-nums">{PARTNER_ID}</span>
        </p>
      </div>

      <div className="border-b border-neutral-200 bg-white">
        <div className="container relative flex h-16 items-center md:h-20">
          <div className="hidden w-[min(100%,22rem)] md:block lg:w-[26rem]">
            <HeaderSearch id="site-search-desktop" />
          </div>

          <Link
            to="/"
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
            onClick={() => setOpen(false)}
          >
            <img
              src="/logo.webp"
              alt={BUSINESS_NAME}
              width={215}
              height={62}
              className="h-10 w-auto md:h-12"
              fetchPriority="low"
              decoding="async"
            />
          </Link>

          <button
            type="button"
            className="ml-auto inline-flex h-10 w-10 items-center justify-center rounded-md md:hidden"
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            aria-expanded={open}
            aria-controls={open ? "mobile-nav" : undefined}
            onClick={() => setOpen((value) => !value)}
          >
            {open ? <X className="h-5 w-5" aria-hidden /> : <Menu className="h-5 w-5" aria-hidden />}
          </button>
        </div>

        <div className="px-4 pb-3 md:hidden">
          <HeaderSearch id="site-search-mobile" onNavigate={() => setOpen(false)} />
        </div>
      </div>

      <nav className={`hidden ${BAR} md:block`} aria-label="Seções da loja">
        <ul className="container flex h-11 items-center justify-center gap-6 lg:gap-8">
          {NAV.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  cn(
                    "text-sm font-medium text-white/85 transition-colors hover:text-white",
                    isActive && "text-white underline decoration-white/70 underline-offset-4",
                  )
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {open ? (
        <div id="mobile-nav" className={`${BAR} px-6 py-4 md:hidden`}>
          <nav className="flex flex-col gap-3" aria-label="Menu">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="text-sm font-medium text-white"
                onClick={() => setOpen(false)}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}
